<template>
  <div>
    <OccupationSelect
      v-show="!noOccupation"
      v-model="computedValue"
      :multiple="true"
    />
    <t-checkbox
      class="checkbox"
      v-model="noOccupation"
    >
      {{ $t('components.occupations.no_occupation') }}
    </t-checkbox>
  </div>
</template>

<script>
import OccupationSelect from '~/components/ResourceSelect/OccupationSelect.vue';

export default {
  props: {
    value: {
      type: Array,
      required: false,
      default: () => ([])
    },
  },

  data() {
    return {
      newValue: this.value ?? [],
      noOccupation: false,
    };
  },


  components: {
    OccupationSelect,
},

  computed: {
    computedValue: {
      get() {
        return this.newValue;
      },

      set(value) {
        this.newValue = value;
        this.$emit('input', value);
        this.$emit('change', value);
      },
    },
  },

  watch: {
    noOccupation(value) {
      this.computedValue = [];
    }
  }
}
</script>

<style lang="scss" scoped>
.checkbox {
  margin-top: $s-6;
}
</style>
